import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import {
  Button,
  InputAdornment,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import React from "react";

const StyledTextField = styled(TextField)(
  ({
    padding,
    borderRadius,
    color,
    placeholderFontSize,
    border,
    error,
    width,
    fontSize,
    labelShrink,
    placeholderFontWeight,
    backgroundColor,
    customStyle,
    flex,
    paddingRight,
    fontWeight,
    input_color,
    multiline,
    boxShadow,
    sizeMedium,
  }) => ({
    flex: flex,
    "& input.Mui-readOnly": {
      borderRight: "1px solid #D0D5DD",
    },
    "& label.MuiFormLabel-root": {
      transform: `translate(14px, ${labelShrink}) scale(1)`,
      backgroundColor: "transparent",
      // padding: "0px 8px",
    },
    "& label.Mui-focused": {
      transform: `translate(14px, -${labelShrink}) scale(0.75)`,
    },
    "& label.MuiFormLabel-filled ": {
      transform: `translate(14px, -${labelShrink}) scale(0.75)`,
    },
    "& .Mui-disabled": {
      backgroundColor: "#F2F4F7",
      color: "#6C6C6C !important",
    },
    "& label.MuiInputLabel-sizeMedium": {
      top: sizeMedium,
    },
    "& label.MuiInputLabel-shrink": {
      top: "0px",
    },

    "& .MuiInputBase-root": {
      background: backgroundColor||'#fff',
      boxShadow: boxShadow,
      borderRadius: borderRadius || "8px",
      paddingRight: paddingRight,
    },
    "& .MuiInputBase-input": {
      padding: padding || "6px 10px",
      fontSize: fontSize || "15px",
      color: input_color,
      fontWeight: fontWeight,
      width: width,
      "&::placeholder": {
        color: error ? "#d32f2f" : color || "#667085",
        opacity: 1,
        fontSize: placeholderFontSize,
        fontWeight: placeholderFontWeight || 400,
      },
    },
    "& .MuiInputBase-inputMultiline": {
      resize: multiline ? "none" : "auto",
    },
    "& .MuiInputAdornment-positionStart": {
      margin: "0px",
    },
    "& .MuiInputAdornment-root": {
      cursor: "pointer",
    },
    "& .MuiSelect-select": {
      fontSize: "14px",
    },
    "& .MuiFormHelperText-root": {
      margin: "2px 0px 0px",
      fontWeight: 600,
    },
    "& fieldset": {
      border: border || "1px solid #D0D5DD",
      borderRadius: borderRadius || "6px",
    },
    "& .Mui-error .MuiOutlinedInput-notchedOutline": {
      borderWidth: "1.4px",
    },
    ...customStyle,
    "@media (max-width: 767px)": {
      "& .MuiInputBase-input": {
        fontSize: "14px",
        "&::placeholder": {
          fontSize: "14px",
        },
      },
    },
  })
);

const CustomButton = styled(Button)(() => ({
  fontSize: "inherit",
  color: "#475467",
  padding: "5px",
}));

const CommonTextField = ({
  placeholder,
  fullWidth = true,
  variant = "outlined",
  startIcon,
  showSelect = false,
  menuItemData,
  handleCurrencyChange,
  currency,
  padding,
  calender = false,
  calenderIcon,
  value,
  readOnly = false,
  borderRadius,
  handleFileChange,
  color,
  placeholderFontSize,
  onChange,
  border,
  error,
  helperText,
  datePickerCalender,
  width,
  fontSize,
  label,
  labelShrink,
  placeholderFontWeight,
  handleIconClick,
  backgroundColor,
  disabled,
  customStyle,
  endIcon,
  flex,
  paddingRight,
  read,
  fontWeight,
  input_color,
  multiline = false,
  rows,
  onBlur,
  handleFocus,
  type = "text",
  CustomIcon,
  maxLength,
  endComponent = null,
  boxShadow,
  defaultValue,
  startShowSelect = false,
  sizeMedium,
  name,
  minRows,
  maxRows,
}) => {
  return calender ? (
    <LocalizationProvider>
      <DatePicker
        value={value}
        onChange={onChange}
        renderInput={(params) => (
          <StyledTextField
            {...params}
            placeholder={placeholder}
            variant={variant}
            fullWidth={fullWidth}
            padding={padding}
            borderRadius={borderRadius}
            color={color}
            placeholderFontWeight={placeholderFontWeight}
            placeholderFontSize={placeholderFontSize}
          />
        )}
      />
    </LocalizationProvider>
  ) : (
    <StyledTextField
      minRows={minRows}
      maxRows={maxRows}
      defaultValue={defaultValue}
      placeholder={placeholder}
      label={label}
      name={name}
      variant={variant}
      type={type}
      fullWidth={fullWidth}
      padding={padding}
      value={value}
      borderRadius={borderRadius}
      color={color}
      placeholderFontSize={placeholderFontSize}
      placeholderFontWeight={placeholderFontWeight}
      onChange={onChange}
      error={error}
      flex={flex}
      helperText={helperText}
      backgroundColor={backgroundColor}
      border={border}
      onKeyDown={onChange}
      onFocus={handleFocus}
      width={width}
      fontSize={fontSize}
      labelShrink={labelShrink}
      disabled={disabled}
      customStyle={customStyle}
      paddingRight={paddingRight}
      fontWeight={fontWeight}
      input_color={input_color}
      multiline={multiline}
      rows={rows}
      onBlur={onBlur}
      boxShadow={boxShadow}
      sizeMedium={sizeMedium}
      InputProps={{
        readOnly: readOnly || read,
        ...(maxLength ? { inputProps: { maxLength: maxLength } } : {}),
        startAdornment: startIcon ? (
          <InputAdornment position="start">{startIcon}</InputAdornment>
        ) : startShowSelect ? (
          <InputAdornment position="start">
            <Select
              value={currency}
              onChange={handleCurrencyChange}
              variant="standard"
              disableUnderline
              style={{ fontSize: "inherit" }}
              disabled={disabled}
            >
              {menuItemData.map((item) => (
                <MenuItem value={item.value}>{item.name}</MenuItem>
              ))}
            </Select>
          </InputAdornment>
        ) : (
          ""
        ),

        endAdornment: (
          <>
            {CustomIcon}
            {endIcon && (
              <InputAdornment position="end">{endIcon}</InputAdornment>
            )}
            {showSelect && (
              <InputAdornment position="end">
                <Select
                  value={currency}
                  onChange={handleCurrencyChange}
                  variant="standard"
                  disableUnderline
                  style={{ fontSize: "inherit" }}
                  disabled={disabled}
                >
                  {menuItemData.map((item) => (
                    <MenuItem value={item.name}>{item.name}</MenuItem>
                  ))}
                </Select>
              </InputAdornment>
            )}
            {datePickerCalender && (
              <InputAdornment position="end" onClick={handleIconClick}>
                {calenderIcon}
              </InputAdornment>
            )}
            {readOnly && (
              <InputAdornment position="end">
                <input
                  type="file"
                  accept=""
                  style={{ display: "none" }}
                  id="upload-button"
                  onChange={handleFileChange}
                  disabled={disabled}
                />
                <label htmlFor="upload-button">
                  <CustomButton
                    variant="text"
                    component="span"
                    startIcon={<FileUploadOutlinedIcon />}
                    disabled={disabled}
                  >
                    Upload
                  </CustomButton>
                </label>
              </InputAdornment>
            )}
            {endComponent}
          </>
        ),
      }}
    />
  );
};

export default CommonTextField;
